import { createIntl } from 'react-intl';
import * as yup from 'yup';

import de from '@src/translations/de.json';

import messages from './PersonalInformationDE.schema.messages';
import { intlCache } from '../LanguageProvider';

const intl = createIntl(
    {
        locale: 'de',
        messages: de
    },
    intlCache
);

const minDataReqPersonalInformationSchemaDE = yup.object().shape({
    title: yup
        .string()
        .required(intl.formatMessage({ ...messages.titleError })),
    first_name: yup
        .string()
        .required(intl.formatMessage({ ...messages.firstNameError })),
    last_name: yup
        .string()
        .required(intl.formatMessage({ ...messages.lastNameError })),
    date_of_birth: yup.object().shape({
        dd: yup
            .string()
            .required(intl.formatMessage({ ...messages.validDateError }))
            .matches(
                /^[0-2]?[0-9]$|[3]?[0-1]$/,
                intl.formatMessage({ ...messages.validDateError })
            ),
        mm: yup
            .string()
            .required(intl.formatMessage({ ...messages.validDateError })),
        yy: yup
            .string()
            .required(intl.formatMessage({ ...messages.validDateError }))
            .min(4, 'Minimum 4')
            .max(4, 'Maximum 4')
            .matches(
                /^(19[0-9]\d|20[0-1]\d|2016)$/,
                intl.formatMessage({ ...messages.validDateError })
            )
    }),
    privacy_policy_agreement_date: yup.date().nullable(true),
    phone: yup.array().of(
        yup.object().shape({
            type: yup.string(),
            number: yup.string().when('type', {
                is: 'main',
                then: () =>
                    yup
                        .string()
                        .transform((currentValue) =>
                            currentValue.replace(/\(|\)|\s+|-|\//g, '')
                        )
                        .matches(
                            /^(0|(\+49)|0049)[0-9]{8,15}$/,
                            intl.formatMessage({
                                ...messages.validMainPhoneError
                            })
                        )
                        .required(
                            intl.formatMessage({ ...messages.mainContactError })
                        ),
                otherwise: () =>
                    yup
                        .string()
                        .transform((currentValue) =>
                            currentValue.replace(/\(|\)|\s+|-|\//g, '')
                        )
                        .matches(
                            /^(0|(\+49)|0049)[0-9]{8,15}$|^$/,
                            intl.formatMessage({
                                ...messages.validMainPhoneError
                            })
                        )
            })
        })
    ),
    addresses: yup.array().of(
        yup.object().shape({
            street_line_1: yup
                .string()
                .required(intl.formatMessage({ ...messages.streetNameError })),
            street_line_2: yup.string(),
            house_number: yup
                .string()
                .required(intl.formatMessage({ ...messages.houseNumberError })),
            flat_number: yup.string(),
            town: yup
                .string()
                .required(intl.formatMessage({ ...messages.townError })),
            postcode: yup
                .string()
                .matches(
                    /^[0-9]{2}[0-9]{3}$/,
                    intl.formatMessage({ ...messages.validPostcodeError })
                )
                .required(intl.formatMessage({ ...messages.noPostcodeError }))
        })
    )
});

const signUpPersonalInformationSchemaDE =
    minDataReqPersonalInformationSchemaDE.shape({
        data_transfer_consent: yup.object().shape({
            agreed: yup.bool(),
            datetime: yup.date()
        })
    });

export {
    minDataReqPersonalInformationSchemaDE as minDataReqPersonalInfoDE,
    signUpPersonalInformationSchemaDE as personalInfoDE
};
